var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center mx-auto"},[_c('cui-register',{staticClass:"mb-3 mt-3 pt-3"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }